<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>现金账户</v-tab>
      <v-tab>现金帐管理</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <cash-book-cash-account />
      </v-tab-item>
      <v-tab-item>
        <cash-book-manage />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CashBookCashAccount from '@/views/AadenPages/cashBook/CashBookCashAccount.vue'
import CashBookManage from '@/views/AadenPages/cashBook/CashBookManage.vue'

export default {
  name: 'PersonalInfoPage',
  components: {
    CashBookManage,
    CashBookCashAccount
  },
  data () {
    return {
      tab: null
    }
  },
  watch: {
  },

  async mounted () {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>
